import _ from 'lodash'
import { bindActionCreators } from 'redux'
import * as appActions from '../../actions/index'

export const bindDispatch = _.memoize(dispatch => ({
  dispatch,
  actions: bindActionCreators(appActions, dispatch)
}))



// WEBPACK FOOTER //
// ./src/app/common/util/redux.js